<label class="checkbox-wrapper">
  <span *ngIf="text" class="label-text ellipsis">{{text}}</span>
  <input class="input-checkbox" [value]="checkboxValue || ''" [(ngModel)]="checked" type="checkbox" (click)="handleCheckboxSelected($event)">
  <span class="checkmark" [ngClass]="{'hyphen': type === 'hyphen'}"></span>
</label>     
<!-- <mis-checkbox
    [type]="checkbox"
    [checked]="checked"
    [disabled]="disabled"
    [value]="checkboxValue"
    (valueChange)="handleCheckboxSelected($event)"
></mis-checkbox>       -->
<!-- <mis-checkbox
class="input-checkbox"
[(ngModel)]="checked"
(click)="handleCheckboxSelected($event)"
></mis-checkbox> -->